document.addEventListener("DOMContentLoaded", () => {

  const cards       = Array.from(document.querySelectorAll(".product_detail_card"));
  const items       = Array.from(document.querySelectorAll(".product_detail_item"));
  const navItems    = Array.from(document.querySelectorAll(".detail_nav_item"));
  const detailSection = document.querySelector(".product_detail_items");
  const bgItems     = Array.from(document.querySelectorAll(".product_detail_bg"));

  if (!cards.length || !items.length || !navItems.length || !detailSection) return;

  const allTabs = navItems
    .filter(n => !n.closest('.slick-cloned'))
    .map(n => n.dataset.tabId);

  let activeIndex = 0;

  function scrollToDetails() {
    const y = detailSection.getBoundingClientRect().top + window.pageYOffset - 80;
    window.scrollTo({ top: y, behavior: "smooth" });
  }

  function clearActive() {
    [...cards, ...items, ...bgItems].forEach(el =>
      el.classList.remove("active", "active-delay", "active-bg")
    );
    document.querySelectorAll(".detail_nav_item").forEach(el =>
      el.classList.remove("active", "active-delay")
    );
  }

  function activateTab(tabId, skipScroll = false, instant = false) {
    clearActive();

    const card = cards.find(c => c.dataset.tabId === tabId);
    const item = items.find(i => i.dataset.tabContent === tabId);
    const bg   = bgItems.find(b => b.dataset.tabContent === tabId);

    card?.classList.add("active");
    item?.classList.add("active");
    bg?.classList.add("active", "active-bg");

    document.querySelectorAll(`.detail_nav_item[data-tab-id="${tabId}"]`).forEach(el =>
      el.classList.add("active")
    );

    activeIndex = allTabs.indexOf(tabId);

    if (instant) {
      card?.classList.add("active-delay");
      item?.classList.add("active-delay");
      bg?.classList.add("active-delay");
      document.querySelectorAll(`.detail_nav_item[data-tab-id="${tabId}"]`).forEach(el =>
        el.classList.add("active-delay")
      );
    } else {
      setTimeout(() => {
        card?.classList.add("active-delay");
        item?.classList.add("active-delay");
        bg?.classList.add("active-delay");
        document.querySelectorAll(`.detail_nav_item[data-tab-id="${tabId}"]`).forEach(el =>
          el.classList.add("active-delay")
        );
      }, 500);
    }

    if (!skipScroll) scrollToDetails();
  }

  cards.forEach(card => {
    card.addEventListener("click", () => {
      const tabId = card.dataset.tabId;
      activateTab(tabId);

      const $nav = $('.detail_nav_inner');
      if ($nav.hasClass('slick-initialized')) {
        let targetIndex = null;
        $nav.find('.slick-slide:not(.slick-cloned)').each(function () {
          if ($(this).find('.detail_nav_item').data('tab-id') === tabId) {
            targetIndex = $(this).data('slick-index');
            return false;
          }
        });
        if (targetIndex !== null) {
          $nav.slick('slickGoTo', targetIndex);
        }
      }
    });
  });

  document.querySelector('.detail_nav_inner')?.addEventListener("click", (e) => {
    const nav = e.target.closest(".detail_nav_item");
    if (!nav) return;

    const tabId = nav.dataset.tabId;

    items.find(i => i.classList.contains("active"))?.classList.remove("active-delay");

    setTimeout(() => {
      activateTab(tabId);

      const $nav = $('.detail_nav_inner');
      if ($nav.hasClass('slick-initialized')) {
        let targetIndex = null;
        $nav.find('.slick-slide:not(.slick-cloned)').each(function () {
          if ($(this).find('.detail_nav_item').data('tab-id') === tabId) {
            targetIndex = $(this).data('slick-index');
            return false;
          }
        });
        if (targetIndex !== null) {
          $nav.slick('slickGoTo', targetIndex);
        }
      }
    }, 500);
  });

  activateTab(allTabs[0], true);


//   const breakpoint = 1200;

//   function initDetailTabsAccordion() {
//     document.querySelectorAll(".info_box").forEach((infoBox) => {
//       const tabs = infoBox.querySelectorAll(".detail_tab");
//       tabs.forEach((tab, index) => {
//         const header = tab.querySelector(".tab_header");
//         if (!header) return;
//         header.onclick = null;
//         header.onclick = () => {
//           tabs.forEach(s => { if (s !== tab) s.classList.remove("is-open"); });
//           tab.classList.toggle("is-open");
//         };
//         index === 0 ? tab.classList.add("is-open") : tab.classList.remove("is-open");
//       });
//     });
//   }

//   function destroyDetailTabsAccordion() {
//     document.querySelectorAll(".detail_tab").forEach(tab => tab.classList.remove("is-open"));
//   }

//   function handleResize() {
//     window.innerWidth < breakpoint ? initDetailTabsAccordion() : destroyDetailTabsAccordion();
//   }

//   handleResize();
//   window.addEventListener("resize", handleResize);
});



$(document).ready(function () {

  let slickGoToInProgress = false;

  let arrowClicked = false;

  function syncSlickToActiveTab($nav) {
    const $activeSlide = $nav.find('.slick-slide:not(.slick-cloned) .detail_nav_item.active')
                             .closest('.slick-slide');
    if ($activeSlide.length) {
      const slideIndex = $activeSlide.data('slick-index');
      if (typeof slideIndex === 'number') {
        $nav.slick('slickGoTo', slideIndex, true);
      }
    }
  }

  function initNavSlick() {
    const $nav = $('.detail_nav_inner');

    if (window.innerWidth < 576) {
      if (!$nav.hasClass('slick-initialized')) {
        $nav.slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          centerMode: true,
          arrows: true,
          prevArrow: $('.icon_prev'),
          nextArrow: $('.icon_next'),
          dots: false,
          swipeToSlide: true
        });

        $(document).on('click.slickArrow', '.icon_prev, .icon_next', function () {
          arrowClicked = true;
          setTimeout(() => { arrowClicked = false; }, 500);
        });

        $nav.on('afterChange', function (event, slick, currentSlide) {
          if (slickGoToInProgress) return;

          const $centerSlide = $nav.find(`.slick-slide[data-slick-index="${currentSlide}"]`);
          const tabId = $centerSlide.find('.detail_nav_item').data('tab-id');

          if (tabId) {
            document.dispatchEvent(
              new CustomEvent('slickActivateTab', { detail: { tabId, animated: arrowClicked } })
            );
          }
        });

        syncSlickToActiveTab($nav);
      }
    } else {
      if ($nav.hasClass('slick-initialized')) {
        $nav.slick('unslick');
        $(document).off('click.slickArrow');
      }
    }
  }

  document.addEventListener('slickActivateTab', (e) => {
    const { tabId, animated } = e.detail;

    const cards   = Array.from(document.querySelectorAll('.product_detail_card'));
    const items   = Array.from(document.querySelectorAll('.product_detail_item'));
    const bgItems = Array.from(document.querySelectorAll('.product_detail_bg'));

    const card = cards.find(c => c.dataset.tabId === tabId);
    const item = items.find(i => i.dataset.tabContent === tabId);
    const bg   = bgItems.find(b => b.dataset.tabContent === tabId);

    if (animated) {
      const currentItem = items.find(i => i.classList.contains('active'));
      const currentBg   = bgItems.find(b => b.classList.contains('active'));
      currentItem?.classList.remove('active-delay');
      currentBg?.classList.remove('active-delay');

      [...cards, ...items, ...bgItems].forEach(el =>
        el.classList.remove('active', 'active-delay', 'active-bg')
      );
      document.querySelectorAll('.detail_nav_item').forEach(el =>
        el.classList.remove('active', 'active-delay')
      );

      card?.classList.add('active');
      item?.classList.add('active');
      bg?.classList.add('active', 'active-bg');
      document.querySelectorAll(`.detail_nav_item[data-tab-id="${tabId}"]`).forEach(el =>
        el.classList.add('active')
      );

      setTimeout(() => {
        card?.classList.add('active-delay');
        item?.classList.add('active-delay');
        bg?.classList.add('active-delay');
        document.querySelectorAll(`.detail_nav_item[data-tab-id="${tabId}"]`).forEach(el =>
          el.classList.add('active-delay')
        );
      }, 500);

    } else {
      [...cards, ...items, ...bgItems].forEach(el =>
        el.classList.remove('active', 'active-delay', 'active-bg')
      );
      document.querySelectorAll('.detail_nav_item').forEach(el =>
        el.classList.remove('active', 'active-delay')
      );

      card?.classList.add('active', 'active-delay');
      item?.classList.add('active', 'active-delay');
      bg?.classList.add('active', 'active-bg', 'active-delay');
      document.querySelectorAll(`.detail_nav_item[data-tab-id="${tabId}"]`).forEach(el =>
        el.classList.add('active', 'active-delay')
      );
    }
  });

  $(document).on('click', '.detail_nav_item', function () {
    slickGoToInProgress = true;
    setTimeout(() => { slickGoToInProgress = false; }, 500);
  });

  initNavSlick();
  $(window).on('resize', initNavSlick);



  
});

const breakpoint = 1200;
const heightLimit = 1000;

function shouldInitAccordion() {
  return window.innerWidth < breakpoint || window.innerHeight < heightLimit;
}
function initAccordion() {
  $(".info_box").each(function () {
    const $box = $(this);
    if ($box.hasClass("acc_init")) return;
    $box.addClass("acc_init");
    const $tabs = $box.find(".detail_tab");
    $tabs.removeClass("is-open")
         .find(".tab_content")
         .hide();
    $tabs.first()
         .addClass("is-open")
         .find(".tab_content")
         .show();

    $box.on("click", ".tab_header", function () {
      const $currentTab = $(this).closest(".detail_tab");
      if ($currentTab.hasClass("is-open")) {
        $currentTab.removeClass("is-open")
                   .find(".tab_content")
                   .stop(true, true)
                   .slideUp(500);
      } else {
        $tabs.removeClass("is-open")
             .find(".tab_content")
             .stop(true, true)
             .slideUp(500);
        $currentTab.addClass("is-open")
                   .find(".tab_content")
                   .stop(true, true)
                   .slideDown(500);
      }
    });

  });
}

function destroyAccordion() {
  $(".info_box.acc_init").each(function () {
    const $box = $(this);
    $box.removeClass("acc_init");
    $box.off("click", ".tab_header");
    $box.find(".detail_tab")
        .removeClass("is-open")
        .find(".tab_content")
        .stop(true, true)
        .show();
  });
}

function handleResize() {
  if (shouldInitAccordion()) {
    initAccordion();
  } else {
    destroyAccordion();
  }
}

$(document).ready(function () {
  handleResize();
  $(window).on("resize", handleResize);
});